import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { iniciarModoPantalla } from './app/auxiliares/modo-pantalla';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

iniciarModoPantalla();

platformBrowserDynamic()
  .bootstrapModule(AppModule, {
    applicationProviders: [provideZoneChangeDetection()],
  })
  .catch((err) => console.error(err));
